"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _sx = _interopRequireDefault(require("../../utils/sx"));
const BoxPropsNotToRendered = ['display', 'alignItems', 'flex', 'position', 'flexDirection', 'width', 'height', 'mt', 'color'];
const Box = _styledComponents["default"].div.withConfig({
  shouldForwardProp: prop => !BoxPropsNotToRendered.includes(prop)
})(_styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.layout, _styledSystem.flexbox, _styledSystem.grid, _styledSystem.background, _styledSystem.border, _styledSystem.position, _styledSystem.shadow, _sx["default"]);
var _default = exports["default"] = Box;